export default "__VITE_ASSET__BLDe26Uu__"